import {Color} from 'three';

export class MarkingType {
    constructor() {
    }

    private _color: Color;

    get color(): Color {
        return this._color;
    }

    set color(value: Color) {
        this._color = value;
    }

    private _comment: string;

    get comment(): string {
        return this._comment;
    }

    set comment(value: string) {
        this._comment = value;
    }

    private _assessmentIndex: number;

    get assessmentIndex(): number {
        return this._assessmentIndex;
    }

    set assessmentIndex(value: number) {
        this._assessmentIndex = value;
    }

    private _burnDegree: string;

    get burnDegree(): string {
        return this._burnDegree;
    }

    set burnDegree(value: string) {
        this._burnDegree = value;
    }
}
